import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d173939"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-btns" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("识别")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("清除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CitySelect = _resolveComponent("CitySelect")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_form_item, { label: "新收件人信息" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "textarea",
          placeholder: "粘贴收件地址识别",
          rows: "4",
          resize: "none",
          modelValue: _ctx.newReceiverInfo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newReceiverInfo) = $event)),
          onBlur: _ctx.handleTrim
        }, null, 8, ["modelValue", "onBlur"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "mini",
            disabled: !_ctx.newReceiverInfo,
            onClick: _ctx.handleIdentify
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "mini",
            plain: "",
            disabled: !_ctx.newReceiverInfo,
            onClick: _ctx.handleClear
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_form_item, {
      label: "省市区",
      class: "is-required",
      prop: "newReceiverPCC"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CitySelect, {
          defaultProvinceObj: _ctx.defaultProvinceObj,
          defaultCityObj: _ctx.defaultCityObj,
          defaultCountyObj: _ctx.defaultCountyObj,
          onCityChange: _ctx.handleCityChange
        }, null, 8, ["defaultProvinceObj", "defaultCityObj", "defaultCountyObj", "onCityChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, {
      label: "详细地址",
      prop: "newReceiverAddress"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请输入详细地址",
          maxlength: "512",
          modelValue: _ctx.editFormData.newReceiverAddress,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editFormData.newReceiverAddress) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, {
      label: "收件人姓名",
      prop: "newReceiverName"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请输入收件人姓名",
          modelValue: _ctx.editFormData.newReceiverName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editFormData.newReceiverName) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, {
      label: "收件人电话",
      prop: "newReceiverPhone"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请输入收件人电话",
          modelValue: _ctx.editFormData.newReceiverPhone,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editFormData.newReceiverPhone) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64))
}